import { Roles } from "../../mp-utils/generic-utils"

export const isUsageActivityLogUserDeleted = record =>
  record["usage_activity_logs.isUserDeleted"] === true ||
  record["usage_activity_logs.isUserDeleted"] === "true"

export const getActivityLogUserLink = record =>
  !isUsageActivityLogUserDeleted(record)
    ? `/reporting/organization/${
        record["usage_activity_logs.userRole"] === Roles.Student
          ? "learners"
          : "instructors"
      }`
    : null
